export default __webpack_public_path__ + "static/media/Tio2.e2a71a6e.png";